import React, { forwardRef } from 'react'
import { InputProps as ChakraInputProps } from '@chakra-ui/core'

import { PseudoBox } from '../PseudoBox'
import { useInputStyle } from '../../hooks/useInputStyle'
import { useFormControl } from '../../hooks/useFormControl'

export interface TextInputProps extends ChakraInputProps {
  onChangeValue?: (value: string) => void
  rows?: number
}

export const TextInput = forwardRef((props: TextInputProps, ref) => {
  const {
    size,
    variant,
    as,
    'aria-label': ariaLabel,
    'aria-describedby': ariaDescribedby,
    isReadOnly,
    isFullWidth,
    isDisabled,
    isInvalid,
    isRequired,
    focusBorderColor,
    errorBorderColor,
    onChange,
    onChangeValue,
    rows,
    ...restProps
  } = props

  const inputStyleProps = useInputStyle(props)
  const formControl = useFormControl(props)

  const handleChange = event => {
    onChange && onChange(event)
    onChangeValue && onChangeValue(event.target.value)
  }

  return (
    <PseudoBox
      ref={ref}
      as={rows ? 'textarea' : as}
      readOnly={formControl.isReadOnly}
      aria-readonly={isReadOnly}
      disabled={formControl.isDisabled}
      aria-label={ariaLabel}
      aria-invalid={formControl.isInvalid}
      required={formControl.isRequired}
      aria-required={formControl.isRequired}
      aria-disabled={formControl.isDisabled}
      aria-describedby={ariaDescribedby}
      onChange={handleChange}
      rows={rows}
      {...inputStyleProps}
      {...restProps}
    />
  )
})

TextInput.displayName = 'TextInput'

TextInput.defaultProps = {
  size: 'md',
  as: 'input',
  variant: 'outline',
  isFullWidth: true,
  focusBorderColor: 'green.400',
  errorBorderColor: 'red.500',
}

export default TextInput
